import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useId, useMemo } from 'react';
import Markdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import { useRemoteUICopy } from './copy.js';
const components = {
    img: ({ alt }) => _jsx("span", { children: alt }),
};
export const MarkdownContent = memo(function MarkdownContent({ markdown, className }) {
    const copy = useRemoteUICopy();
    const id = useId();
    const prefix = `agent-markdown-${id}-`;
    const scopedComponents = useMemo(() => ({
        ...components,
        table: ({ children }) => _jsx("div", { className: "agent-markdown-table", role: "region", "aria-label": copy.markdownTable, tabIndex: 0, children: _jsx("table", { children: children }) }),
        a: ({ node, href, children, 'aria-describedby': describedBy, ...props }) => href
            ? _jsx("a", { ...props, href: href, rel: "noreferrer", "aria-describedby": describedBy === 'footnote-label' ? `${prefix}footnote-label` : describedBy, children: children })
            : _jsx(_Fragment, { children: children }),
        h2: ({ node, id: headingId, ...props }) => _jsx("h2", { ...props, id: headingId === 'footnote-label' ? `${prefix}footnote-label` : headingId }),
    }), [prefix, copy]);
    return _jsx("div", { className: `agent-markdown${className ? ` ${className}` : ''}`, children: _jsx(Markdown, { remarkPlugins: [remarkGfm, remarkBreaks], remarkRehypeOptions: { clobberPrefix: prefix, footnoteLabel: copy.footnotes, footnoteBackLabel: copy.footnoteBack }, components: scopedComponents, urlTransform: safeLink, children: markdown }) });
});
function safeLink(value) {
    if (value.startsWith('/') || value.startsWith('#'))
        return value;
    try {
        const url = new URL(value);
        return url.protocol === 'http:' || url.protocol === 'https:' || url.protocol === 'mailto:'
            ? value
            : undefined;
    }
    catch {
        return undefined;
    }
}
//# sourceMappingURL=MarkdownContent.js.map